import {
    SELECTED_BRAND,
    VIEW_POSTS,
    ADD_NEW_POST,
    UPDATE_POST,
    UPDATE_BRAND_POST,
    UPDATE_POST_STATUS,
    UPDATE_ALL_POSTS_STATUS,
    SELECTED_POST,
    DELETE_POST,
} from '../constants/action-types/posts';

export const setSelectedBrand = (brand) => {
    return {
        type: SELECTED_BRAND,
        payload: brand,
    }
};

export const setPostsForBrand = (posts=[]) => {
    return {
        type: VIEW_POSTS,
        payload: posts
    };
};

export const setSelectedPost = (post) => {
    return {
        type: SELECTED_POST,
        payload: post
    }
};

export const addNewPost = (psot) => {
    return {
        type: ADD_NEW_POST,
        payload: psot
    };
};

export const updatePost = (post) => {
    return {
        type: UPDATE_POST,
        payload: post,
    };
};

// Companion to updatePost — mirrors an edited post into the big data
// structure (state.user.brands[].posts + the derived state.user.allPosts)
// so the AllPostsPage views and the brand tree-view reflect the edit in
// real time, without waiting for a page refresh / brand re-fetch.
// Dispatch this alongside updatePost from the edit-save handler.
export const updateBrandPost = (post) => {
    return {
        type: UPDATE_BRAND_POST,
        payload: post,
    };
};

export const updatePostStatus = ({ postId, statusId, queueStatus }) => {
    return {
        type: UPDATE_POST_STATUS,
        payload: { postId, statusId, queueStatus },
    }
};

// Companion to updatePostStatus — updates the user.allPosts slice the
// AllPostsPage Kanban renders from. Dispatch both from drag handlers.
export const updateAllPostsStatus = ({ postId, statusId, queueStatus }) => {
    return {
        type: UPDATE_ALL_POSTS_STATUS,
        payload: { postId, statusId, queueStatus },
    }
};

// Drop a post from state.post.posts on successful DELETE. Dispatched
// from DeletePostModal alongside companyAdminDeletePost (which only
// touches a different slice).
export const deletePost = (postId) => {
    return {
        type: DELETE_POST,
        payload: postId,
    }
};

